import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';
import GoBack from '../../../globalComponents/GoBack';

const columns = [
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: 'reference',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    ellipsis: true,
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'From',
    dataIndex: 'from',
    key: 'from',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'To',
    dataIndex: 'to',
    key: 'to',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    width: '10%',
    className: 'whitespace-nowrap font-medium dark:text-white',
    render: (_, record) => <span className={record.quantity === 0 ? "text-black-500" : record.quantity > 0 ? "text-green-500 " : record.quantity < 0 && "text-red-500"}>{Math.abs(record.quantity)}</span> 
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'waiting' ? "text-blue-600 bg-blue-100 w-max" : record.status === 'done' ? "text-green-950 bg-green-100 w-max" : record.status === 'draft' && "text-slate-950 bg-slate-100 w-max"}>{record.status}</Badge>
  },

]



const ProductMoves = () => {
  const history = useLoaderData();
  // const navigate = useNavigate();
  const { CustomBreadcrumb } = useOutletContext();
  // const onRow = (record, rowIndex) => {
  //   return {
  //     onClick: () => navigate('/inventory/products/'+record.seo)
  //   };
  // }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'><CustomBreadcrumb/></h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <GoBack />Back
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        // onRow={onRow}
        // rowClassName={'hover:cursor-pointer'}
        dataSource={history}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'number'}
      />
    
    </div>
  )
}

export default ProductMoves;